import React from 'react'

export const Login = [
  {
    name: 'institution',
    component: React.lazy(() => import('../../modules/login/ChooseInstitutionComponent')),
    path: '/login',
    guards: ['allowOnlyNotLogged'],
    redirect: '/',
  },
  {
    name: 'form',
    component: React.lazy(() => import('../../modules/login/LoginFormComponent')),
    path: '/login/:institution',
    guards: ['allowOnlyNotLogged'],
    redirect: '/',
  },
]
